import { render, staticRenderFns } from "./SettingsDivs.vue?vue&type=template&id=f7e65f30"
import script from "./SettingsDivs.vue?vue&type=script&lang=js"
export * from "./SettingsDivs.vue?vue&type=script&lang=js"
import style0 from "./SettingsDivs.vue?vue&type=style&index=0&id=f7e65f30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports